import * as React from 'react';
import { Provider } from '../../redux/scheduling/types';
import { ProviderPicker } from '../core/ProviderPicker';

export interface MASelectorProps {
  onChange?: (value?: Provider) => void;
  scheduledMAsByMarket: {
    [market: string]: Provider[];
  }[];
  shiftMarket: string;
  selectedMA?: Provider;
}

export interface MASelectorState {
  selectedMA?: Provider;
}

export class MASelector extends React.Component<MASelectorProps, MASelectorState> {
  public static defaultProps: MASelectorProps = {
    scheduledMAsByMarket: [],
    shiftMarket: '',
  };

  /*
   * Lifecycle
   */
  public constructor(props: MASelectorProps) {
    super(props);

    this.state = {
      selectedMA: this.props.selectedMA,
    };
  }

  public render(): JSX.Element {
    let inMarketMAs: Provider[] = [];
    const allMAs: Provider[][] = this.props.scheduledMAsByMarket.map((o) => {
      const market = Object.keys(o)[0];
      o[market].forEach((ma) => {
        ma.marketCode = market;
      });
      if (market === this.props.shiftMarket) {
        inMarketMAs = o[market];
      }
      return o[market];
    });

    const flattened = ([] as Provider[]).concat(...allMAs);
    const uniq = Array.from(new Set(flattened));

    return (
      <div className="ma-selector">
        <ProviderPicker onProviderSelected={this.onChanged} providers={uniq} selected={this.state.selectedMA} suggested={inMarketMAs} />
      </div>
    );
  }

  /*
   * Lambdas
   */
  private onChanged = (ma?: Provider) => {
    this.setState({ selectedMA: ma });
    if (this.props.onChange) {
      this.props.onChange(ma);
    }
  };
}
